import { Injector, Injectable } from '@angular/core';
import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';
import { Subject, takeUntil } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getCurrentUserProfile } from '../selectors/ad-user.selectors';
import * as i0 from "@angular/core";
export class GraphApiLoggingTransformer extends LoggerParamsTransformer {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.destroy$ = new Subject();
    }
    initialize() {
        const store = this.injector.get(Store);
        store
            .pipe(select(getCurrentUserProfile))
            .pipe(takeUntil(this.destroy$))
            .subscribe((user) => (this.user = user));
    }
    getParams() {
        return {
            userType: this.user && this.user.userType,
            uuid: this.user && this.user.objectId
        };
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
    static { this.ɵfac = function GraphApiLoggingTransformer_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GraphApiLoggingTransformer)(i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GraphApiLoggingTransformer, factory: GraphApiLoggingTransformer.ɵfac }); }
}
//# sourceMappingURL=graph-api-logging-transformer.js.map